export var FONT_AWESOME_DEFAULT_PREFIX = 'fas';